const managePayment = {
  managePayment: {
    pageTitle: '결제 관리',
    description: '모든 결제 내역을 조회 및 관리하고 환불 요청을 처리합니다.',
    tabs: {
      pending: '결제 대기',
      complete: '결제 완료',
      failed: '결제 실패',
      refunded: '환불 완료'
    },
    filters: {
      paymentMethod: '결제 수단',
      search: '검색'
    },
    buttons: {
      search: '검색',
      reset: '초기화',
      refund: '환불',
      refunded: '환불됨',
      processing: '처리 중...',
      close: '닫기',
      forceComplete: '완료 처리'
    },
    loadingText: '데이터를 불러오는 중...',
    refundModal: {
      title: '환불 확인',
      body: '이 주문을 정말로 환불하시겠습니까?\n주문 ID: {{orderId}}\n이 작업은 되돌릴 수 없습니다.'
    },
    alerts: {
      loadFailed: '결제 데이터를 불러오는데 실패했습니다. 다시 시도해주세요.',
      statusUpdateFailed: '상태 변경에 실패했습니다.',
      refundFailed: '환불 처리에 실패했습니다.'
    }
  }
};

export default managePayment;